import React, { FC, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from '../../../translations';

interface Reset2FAProps {
  readonly userId: number;
  readonly refresh: () => void;
}

export const ResetSecondFactorButton: FC<Reset2FAProps> = ({ userId, refresh }) => {
  const { ts } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  async function removeSecondFactor(): Promise<void> {
    setIsLoading(true);
    const factors = await api.getSecondFactors(userId);

    for (const factor of factors) {
      await api.deleteSecondFactor(factor.id);
    }

    setIsLoading(false);
    setIsOpen(false);
    refresh();
  }

  return (
    <>
      <Modal className="modal-large" id="removeSecondFactorModal" isOpen={isOpen}>
        <ModalHeader>{ts('remove_second_factor')}</ModalHeader>
        <ModalBody>
          {ts('are_you_sure_you_want_to_remove_second_factor_authentication_from_the_user')}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={isLoading}
            id="removeSecondFactor"
            onClick={removeSecondFactor}
          >
            {ts('remove')}
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            {ts('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Button
        block
        id="promptRemoveSecondFactor"
        onClick={() => {
          setIsOpen(true);
        }}
        type="submit"
      >
        {ts('reset_2fa')}
      </Button>
    </>
  );
};
